<app-chat-legacy
  *ngIf="legacy; else modernTemplate"
  [ngClass]="{ 'alc-spinner-big': isLoading }"
  [isLoading]="isLoading"></app-chat-legacy>

<ng-template #modernTemplate>
  <span [class.customization]="customizationService.customization" [ngClass]="customizationService.position">
    <app-chat [isLoading]="isLoading"></app-chat>
    <ng-container *ngIf="customizationService.customization">
      <router-outlet></router-outlet>
    </ng-container>
  </span>
</ng-template>
